'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _reduxForm = require('redux-form');

var _formComponents = require('components/formComponents');

var _contacts = require('redux/modules/contacts');

var _components = require('components');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var contactFormDefaults = {
  name: '',
  surname: '',
  email: ''
};

var ContactForm = (_dec = (0, _reactRedux.connect)(null, { addContact: _contacts.addContact }), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'contactForm',
  propNamespace: 'contactForm',
  initialValues: contactFormDefaults
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ContactForm, _Component);

  function ContactForm() {
    (0, _classCallCheck3.default)(this, ContactForm);
    return (0, _possibleConstructorReturn3.default)(this, (ContactForm.__proto__ || (0, _getPrototypeOf2.default)(ContactForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(ContactForm, [{
    key: 'addContact',
    value: function addContact(formData) {
      var _props = this.props,
          groupId = _props.groupId,
          reset = _props.contactForm.reset,
          onAdd = _props.onAdd;

      var promise = this.props.addContact((0, _extends3.default)({}, formData, { groupId: groupId })).promise;
      promise.then(function () {
        reset();
        onAdd();
      });
      return promise;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          _props2$contactForm = _props2.contactForm,
          handleSubmit = _props2$contactForm.handleSubmit,
          submitting = _props2$contactForm.submitting,
          invalid = _props2$contactForm.invalid;


      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit(this.addContact) },
        _react2.default.createElement(_reduxForm.Field, { name: 'name', type: 'text', component: _formComponents.formSimpleTextInput, placeholder: t('First name'), labelClass: 'faded', hideLabel: true }),
        _react2.default.createElement(_reduxForm.Field, { name: 'surname', type: 'text', component: _formComponents.formSimpleTextInput, placeholder: t('Last name'), labelClass: 'faded', hideLabel: true }),
        _react2.default.createElement(_reduxForm.Field, { name: 'email', type: 'email', component: _formComponents.formSimpleTextInput, placeholder: t('Email'), labelClass: 'faded', hideLabel: true }),
        _react2.default.createElement(
          'button',
          { type: 'submit', className: 'btn btn-primary pos-rel', disabled: submitting || invalid },
          t('Create contact'),
          submitting && _react2.default.createElement(_components.Loader, { mask: true })
        )
      );
    }
  }]);
  return ContactForm;
}(_react.Component), _class3.propTypes = {
  addContact: _propTypes2.default.func,
  contactForm: _propTypes2.default.object,
  groupId: _propTypes2.default.number,
  onAdd: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  groupId: 0,
  onAdd: function onAdd() {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'addContact', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addContact'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = ContactForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Contacts/Contacts/ContactForm.js
// module id = 2148
// module chunks = 1